<template lang="pug">
.tabs.home
  #preloader(v-if="gameLaunching")
    #loader
  .tabs-holder
    router-link.ggt(to="/" :class="{'aaa': currentPath==='/'}")
      img(src='/new/img/menu/m-hot.png')
      span Hot
    //- router-link.ggt.epic(to="epic" :class="{'aaa': currentPath==='/epic'}")
      img(src='/new/img/menu/m-hot.png')
    router-link.ggt.epic(to="slot" :class="{'aaa': currentPath==='/slot'}")
      img(src='/new/img/menu/m-epic.gif')
      span.text-capitalize {{$t('ui.slots')}}
    router-link.ggt(to="casino" :class="{'aaa': currentPath==='/casino'}")
      img(src='/new/img/menu/m-live.png')
      span.text-capitalize {{$t('ui.live')}}
    router-link.ggt(to="table" :class="{'aaa': currentPath==='/table'}")
      img(src='/new/img/menu/m-poker.png')
      span Poker
    //- a.ggt(href='#' dd='sabong')
    router-link.ggt(to="bingo" :class="{'aaa': currentPath==='/bingo'}")
      img(src='/new/img/menu/m-bingo.png')
      span Bingo
    router-link.ggt(to="hash" :class="{'aaa': currentPath==='/hash'}")
      img(src='/new/img/menu/m-hash.png')
      span Hash
    //- a.ggt(href="javascript:void(0)" @click="launchSabong")
    //- router-link.ggt(to="sabong" :class="{'aaa': currentPath==='/sabong'}")
      img(src='/new/img/menu/m-cock.png')
      span Sabong
    //- a.ggt(href="javascript:void(0)" @click="launchWbet")
    router-link.ggt(v-if="isLoggedIn" to="/launchWbet" target="_blank")
      img(src='/new/img/menu/m-sport.png')
      span Sports
    a.ggt(v-else href="javascript:void(0)" @click="$router.push('/login').catch(err => {})")
      img(src='/new/img/menu/m-sport.png')
      span Sports
    router-link.ggt(to="fishing" :class="{'aaa': currentPath==='/fishing'}")
      img(src='/new/img/menu/m-fish.png')
      span Fishing
    //- router-link.ggt(to="freeplay" :class="{'aaa': currentPath==='/freeplay'}")
    //-   img(src='/new/img/menu/m-demo.png')
    //-   span Demo Play
    //- router-link.ggt(to="review" :class="{'aaa': currentPath==='/review'}")
    //-   img(src='/new/img/menu/m-review.png')
    //-   span {{$tc('ui.review')}}
    //- router-link.ggt(to="news" :class="{'aaa': currentPath==='/news'}")
    //-   img(src='/new/img/menu/m-news.png')
    //-   span News
    //- router-link(to="referral" :class="{'aaa': currentPath==='/referral'}")
      img(src='/new/img/menu/m-refer1.png')
      span {{$t('ui.referral')}}
    //- router-link(v-if="isLoggedIn" to="profile" :class="{'aaa': currentPath==='/profile'}")
      img(src='/new/img/menu/m-setting.png')
      span {{$t('ui.setting')}}
    //- a(href='#')
    //-   img(src='/new/img/m/menu/event.png')
</template>
<script>
export default {
  data(){
    return {
      feedback: {
        success: true,
        status: ""
      },
      gameLaunching:false,
      // counter: 0,
      isActive: 0,
      currentPath:"",
      mobileDevice: false
    }
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
  },
  watch:{
    $route (to, from){
      this.currentPath = to.path
    }
  },
  mounted(){
    this.getMobile()
    this.currentPath = this.$router.currentRoute.path
  },
  methods:{
    setActive(target){
      this.isActive = target
    },
    getMobile() {
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        this.mobileDevice = true
      }else{
        this.mobileDevice = false
      }
    },
    launchWbet(){
      if (this.sessionToken) {
				var vm = this
        let player_id = this.accountID
        let auth_token = this.sessionToken
        let type = (this.mobileDevice ? 2 : 1).toString()
        let lang_code = this.getLanguage
        this.$store
          .dispatch("user/launchWbet", { player_id, auth_token,type, lang_code })
          .then(response => {
            if (response.success == true) {
							setTimeout(() => {
								window.open(response.data, "_blank")
							})
            } else {    
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);    
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              if(response.status === 'free_credit_detected'){
                this.$swal({
                  title: vm.$tc("ui.attention"),
                  text: vm.$tc("message.list.free_credit_detected"),
                  showCancelButton: true,
                  type: "info",
                  confirmButtonText: vm.$tc("ui.ok"),
                  cancelButtonText: vm.$tc("ui.deposit"),
                }).then(result => {
                  if (result.value) {
                    vm.$router.push("/").catch(error =>{})
                  } else if (result.dismiss) {
                    if(result.dismiss === 'cancel'){
                      vm.$router.push("/deposit").catch(error =>{})
                    }
                  }
                });
              }else{
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              } 
            }
          });
      }else{
				this.$router.push("/login").catch(err => {});
			}
    },
  }
}
</script>